import PropTypes from "prop-types"
import { Typography } from "@material-ui/core"
import React from "react"

import useStyles from "./styles"
import LoadingButton from "../../../LoadingButton/index"
import classNames from "classnames"

const GreenButton = ({ children, variant, className = "", ...other }) => {
  const classes = useStyles()

  return (
    <LoadingButton
      variant={variant || "contained"}
      color="inherit"
      className={classNames(className, {
        [classes.containedGreen]: variant === "contained",
        [classes.outlinedGreen]: variant === "outlined",
      })}
      {...other}
    >
      <Typography variant="button">{children}</Typography>
    </LoadingButton>
  )
}

GreenButton.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  className: PropTypes.string,
}

export default GreenButton
